<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h2 id="pgepubid00008">CHAPTER IV</h2>
</div>
<h3 class="calibre1 sigil_not_in_toc" id="pgepubid00009">ELK</h3>
<p class="pindent"><span>T</span>HERE was no detective in the world who looked less
like a police officer, and a clever police officer, than
Elk. He was tall and thin, and a slight stoop accentuated
his weediness. His clothes seemed ill-fitting, and hung upon
rather than fitted him. His dark, cadaverous face was set
permanently in an expression of the deepest gloom, and few
had ever seen him smile. His superiors found him generally
a depressing influence, for his outlook on life was prejudiced
and apparently embittered by his failure to secure promotion.
Faulty education stood in his way here. Ten times he
had come up for examination, and ten times he had failed,
invariably in the same subject—history.</p>
<p class="pindent">Dick, who knew him better than his immediate chiefs,
guessed that these failures did not worry Mr. Elk as much
as people thought. Indeed, he often detected a glum pride
in his inability to remember historical dates, and once, in
a moment of astonishing confidence, Elk had confessed that
promotion would be an embarrassment to a man of his limited
educational attainments. For Elk’s everyday English was
one of his weaknesses.</p>
<p class="pindent">“There’s no rest for the wicked, Mr. Gordon,” he sighed
as he sat down. “I thought I’d get a holiday after my trip
to the U.S.A.”</p>
<p class="pindent">“I want to know all about Lola Bassano—who are her
friends, why she has suddenly attached herself to Raymond
Bennett, a clerk in the employ of Maitlands Consolidated.
Particularly why she picked him up at the corner of St.
James’s Square and drove him to Horsham last night. I saw
them by accident as I was coming out of my club, and followed.
They sat in her coupé for the greater part of two hours within
a hundred yards of Bennett’s house, and they were talking.
I know, because I stood in the rain behind the car, listening.
If he had been making love to her I should have understood—a
little. But they were talking, and talking money. I
heard certain sums mentioned. At four o’clock he got out
of the car and went into his house, and Lola drove off.”</p>
<p class="pindent">Elk, puffing, sadly shook his head.</p>
<p class="pindent">“Lola wouldn’t talk about anything but money anyway,”
he said. “She’s like Queen What’s-her-name who died in
1077, or maybe it was 1573. She married King Henry, or it
may have been Charles, because she wanted a gold snuff-box
he had. I’m not sure whether it was a gold snuff-box or a
silver bed. Anyway, she got it an’ was be’eaded in . . . I
don’t remember the date.”</p>
<p class="pindent">“Thank you for the parallel,” smiled Dick. “But Lola
is not after snuff-boxes of gold or silver. Young Bennett
hasn’t twopence of his own. There is something particularly
interesting to me about this acquaintance.”</p>
<p class="pindent">Elk smoked thoughtfully, watching the smoke rings rise
to the ceiling.</p>
<p class="pindent">“Bennett’s got a sister,” he said, to the other’s amazement.
“Pretty, as far as looks go. Old man Bennett’s a
crook of some kind. Doesn’t do any regular work, but goes
away for days at a time and comes back looking ill.”</p>
<p class="pindent">“You know them?”</p>
<p class="pindent">Elk nodded.</p>
<p class="pindent">“Old man Bennett attracted me. Somebody reported
his movements as suspicious—the local police. They’ve got
nothing to do except guard chickens, and naturally they look
on anybody who doesn’t keep chickens as bein’ a suspicious
character. I kept old Bennett under observation, but I never
got to the bottom of his movements. He has run lots of queer
stunts. He wrote a play once and put it on. It went dead
on the fourth night. Then he took to playing the races on
a system. That nearly broke him. Then he started a correspondence
school at Horsham—‘How to write good English’—and
he lost money. Now he’s taking pictures.”</p>
<p class="pindent">“How long has he been trying those methods of getting
a living?”</p>
<p class="pindent">“Years. I traced a typewriting agency to him seventeen
years ago. They haven’t all been failures. He made money
out of some. But I’d give my head to know what his regular
game is. Once a month regular, sometimes twice, sometimes
more often, he disappears and you can’t find him or trail
him. I’ve sounded every crook in town, but they’re as
much puzzled as I am. Lew Brady—that’s the big sporting
fellow who worked with Lola—he’s interested too. He hates
Bennett. Years ago he tackled the old man and tried to
bully him into telling him what his lay was, and Bennett
handled him rough.”</p>
<p class="pindent">“The old man?” asked Dick incredulously.</p>
<p class="pindent">“The old man. He’s as strong as an ox. Don’t forget it.
I’ll see Lola. She’s not a bad girl—up to a point. Personally,
vamps never appeal to me. Genter’s dead, they tell
me? The Frog’s in that too?”</p>
<p class="pindent">“There’s no doubt about it,” said Dick, rising. “And
here, Elk, is one of the men who killed him.”</p>
<p class="pindent">He walked to the window and looked out, Elk behind him.
The man who had stood on the sidewalk had disappeared.</p>
<p class="pindent">“Where?” asked Elk.</p>
<p class="pindent">“He’s gone now. I——”</p>
<p class="pindent">At that moment the window shattered inward, and splinters
of glass stung his face. Another second, and Elk was dragged
violently to cover.</p>
<p class="pindent">“From the roof of Onslow Gardens,” said Richard Gordon
calmly. “I wondered where the devils would shoot from—that’s
twice they’ve tried to get me since daylight.”</p>
<p class="pindent">A spent cartridge on the flat roof of 94, Onslow Gardens,
and the print of feet, were all the evidence that the assassin
left behind. No. 94 was empty except for a caretaker, who
admitted that he was in the habit of going out every morning
to buy provisions for the day. Admission had been gained
by the front door; there was a tradesman who saw a man
let himself into the house, carrying what looked to be a fishing-rod
under his arm, but which undoubtedly was a rifle in a
cloth case.</p>
<p class="pindent">“Very simple,” said Dick; “and, of course, from the
Frog’s point of view, effective. The shooter had half-a-dozen
ways of escape, including the fire-escape.”</p>
<p class="pindent">Elk was silent and glum. Dick Gordon as silent, but
cheerful, until the two men were back in his office.</p>
<p class="pindent">“It was my inquiry at the garage that annoyed them,”
he said, “and I’ll give them this credit, that they are rapid!
I was returning to my house when the first attempt was
made. The most ingenious effort to run me down with a light
car—the darned thing even mounted the pavement after me.”</p>
<p class="pindent">“Number?”</p>
<p class="pindent">“XL.19741,” said Dick, “but fake. There is no such
number on the register. The driver was gone before I could
stop him.”</p>
<p class="pindent">Elk scratched his chin, surveying the youthful Public
Prosecutor with a dubious eye.</p>
<p class="pindent">“Almost sounds interesting to me,” he said. “Of course
I’ve heard of the Frogs, but I didn’t give much attention.
Nowadays secret societies are so common that every time a
man shakes hands with me, he looks sort of disappointed if
I don’t pull my ear or flap my feet. And gang work on a
large scale I’ve always looked upon as something you only
hear about in exciting novels by my old friend Shylock——”</p>
<p class="pindent">“Sherlock—and he didn’t write them,” murmured Dick.</p>
<p class="pindent">Again Elk fingered his cheek.</p>
<p class="pindent">“I don’t believe in it, anyway,” he said after thought.
“It’s not natural that tramps should do anything systematic.
It’s too much like work. I’ll bet there’s nothing in it, only
a lot of wild coincidences stickin’ together. I’ll bet that the
Frogs are just a silly society without any plan or reason.
And I’ll bet that Lola knows all about ’em,” he added
inconsistently.</p>
<p class="pindent">Elk walked back to “The Yard” by the most circuitous
route. With his furled and ancient umbrella hanging on
his arm, he had the appearance of an out-of-work clerk.
His steel-rimmed spectacles, clipped at a groggy angle,
assisted the illusion. Winter and summer he wore a soiled
fawn top-coat, which was invariably unbuttoned, and he
had worn the same yellowish-brown suit for as long as anybody
could remember. The rain came down, not in any great
quantities, but incessantly. His hard derby hat glistened
with moisture, but he did not put up his umbrella. Nobody
had ever seen that article opened.</p>
<p class="pindent">He walked to Trafalgar Square and then stopped, stood
in thought for some time, and retraced his steps. Opposite
the Public Prosecutor’s office stood a tall street-seller with
a little tray of matches, key-rings, pencils and the odds
and ends that such men sell. His wares, for the moment,
were covered by a shining oil-cloth. Elk had not noticed
him before, and wondered why the man had taken up so
unfavourable a stand, for the end of Onslow Gardens, the
windiest and least comfortable position in Whitehall, is not
a place where the hurrying pedestrian would stop to buy,
even on a fine day. The hawker was dressed in a shabby raincoat
that reached to his heels; a soft felt hat was pulled down
over his eyes, but Elk saw the hawk-like face and stopped.</p>
<p class="pindent">“Busy?”</p>
<p class="pindent">“Naw.”</p>
<p class="pindent">Elk was immediately interested. This man was American,
and was trying to disguise his voice so that it appeared Cockney—the
most impossible task that any American had ever
undertaken, for the whine and intonation of the Cockney are
inimitable.</p>
<p class="pindent">“You’re American—what state?”</p>
<p class="pindent">“Georgia,” was the reply, and this time the hawker made
no attempt at disguise. “Came over on a cattle-boat during
the war.”</p>
<p class="pindent">Elk held out his hand.</p>
<p class="pindent">“Let me see that licence of yours, brother,” he said.</p>
<p class="pindent">Without hesitation the man produced the written police
permit to sell on the streets. It was made out in the name of
“Joshua Broad,” and was in order.</p>
<p class="pindent">“You’re not from Georgia,” said Elk, “but that doesn’t
matter. You’re from Hampshire or Massachusetts.”</p>
<p class="pindent">“Connecticut, to be exact,” said the man coolly, “but
I’ve lived in Georgia. Want a key-ring?”</p>
<p class="pindent">There was a gleam of amusement in his eyes—the merest
flash.</p>
<p class="pindent">“No. Never had a key. Never had anything worth
locking up,” said Elk, fingering the articles on the tray. “Not
a good pitch, this.”</p>
<p class="pindent">“No,” said the other; “too near to Scotland Yard, Mr.
Elk.”</p>
<p class="pindent">Elk cast a swift glance at the man.</p>
<p class="pindent">“Know me, do you?”</p>
<p class="pindent">“Most people do, don’t they?” asked the other innocently.</p>
<p class="pindent">Elk took the pedlar in from the soles of his stout shoes
to his soddened hat, and, with a nod, went on. The hawker
looked after the detective until he was out of sight, and then,
fixing a cover over his tray, strapped it tight and walked in
the direction Elk had taken.</p>
<p class="pindent">Coming out of Maitlands to lunch, Ray Bennett saw a
shabby and saturnine man standing on the edge of the pavement,
but gave him no more than a passing glance. He,
at any rate, did not know Elk and was quite unconscious
of the fact that he was being followed to the little chop-house
where Philo Johnson and he took their modest luncheon.</p>
<p class="pindent">In any circumstances Ray would not have observed the
shadow, but to-day, in his condition of mind, he had no
thought for anybody but himself, or any offence but the
bearded and ancient Maitland’s outrageous behaviour.</p>
<p class="pindent">“The old devil!” he said as he walked by Johnson’s side.
“To make a ten per cent cut in salaries and to start on me!
And this morning the papers say that he has given five
thousand to the Northern Hospitals!”</p>
<p class="pindent">“He’s a charitable cuss, and as to the cut, it was either
that or standing you off,” said Johnson cheerfully. “What’s
the use of kicking? Trade has been bad, and the stock
market is as dead as Ptolemy. The old man wanted to put
you off—said that you were superfluous anyway. If you’d
only look on the bright side of things, Ray——”</p>
<p class="pindent">“Bright!” snorted the young man, his face going pink
with anger. “I’m getting a boy’s salary, and I want money
mighty badly, Philo.”</p>
<p class="pindent">Philo sighed, and for once his good-humoured face was
clouded. Then it relaxed into a broad grin.</p>
<p class="pindent">“If I thought the same way as you, I’d go mad or turn
into a first-class crook. I only earn about fifty per cent
more than you, and yet the old man allows me to handle
hundreds of thousands. It’s too bad.”</p>
<p class="pindent">Nevertheless, the “badness” of the parsimonious Maitland
did not interfere with his appetite.</p>
<p class="pindent">“The art of being happy,” he said as he pushed back his
plate and lit a cigarette, “is to want nothing. Then you’re
always getting more than you need. How is your sister?”</p>
<p class="pindent">“She’s all right,” said Ray indifferently. “Ella’s the
same mind as you. It’s easy to be a philosopher over other
people’s worries. Who’s that disreputable bird?” he added,
as a man seated himself at a table opposite to them.</p>
<p class="pindent">Philo fixed his glasses—he was a little near-sighted.</p>
<p class="pindent">“That’s Elk—a Scotland Yard man,” he said, and grinned
at the new-comer, a recognition which, to Ray’s annoyance—and
his annoyance was tinged with uneasiness—brought
the seedy man to their table.</p>
<p class="pindent">“This is my friend, Mr. Bennett—Inspector Elk, Ray.”</p>
<p class="pindent">“Sergeant,” suggested Elk dourly. “Fate has always
been against me in the matter of promotion. Can’t remember
dates.”</p>
<p class="pindent">So far from making a secret of his failure, Mr. Elk was
never tired of discussing the cause.</p>
<p class="pindent">“Though why a man is a better thief-taker for knowin’
when George Washington was born and when Napoleon
Bonaparte died, is a mystery to me. Dine here every day,
Mr. Bennett?”</p>
<p class="pindent">Ray nodded.</p>
<p class="pindent">“Know your father, I think—John Bennett of Horsham,
isn’t it? Thought so.”</p>
<p class="pindent">In desperation Ray got up with an excuse and left them
alone.</p>
<p class="pindent">“Nice boy, that,” said Elk.</p>
<div class="calibre2"><span id="Page_31" title="31"></span><div class="pg-boilerplate" id="calibre_pb_1"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?fc7779e4